export default __webpack_public_path__ + "static/media/no-data.2f14d372.svg";